import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { observer } from 'mobx-react-lite';

import { DefaultAppProps } from '../App';

import { getKeyframes } from '@egr/xbox/utils/tss-react';
import { makeStyles, MakeStylesHook } from '@egr/xbox/utils/tss-react';
import { PauseIcon } from '../layout/icons/Pause';
import { PlayIcon } from '../layout/icons/Play';

const useHeaderBarStyles: MakeStylesHook<'animatedButton'> = makeStyles({ name: 'HeaderBar' })({
    animatedButton: {
        animation: getKeyframes('0% { transform: scale(1); } 50% { transform: scale(1.5); } 100% { transform: scale(1); }', '3s infinite'),
    },
});

export const CameraPathButton: React.FC<DefaultAppProps> = observer(
    (props) => {
        const { classes } = useHeaderBarStyles();
        const [pathAnimationWasStarted, setFlag] = React.useState(false);

        function onStartAnimation() {
            props.app.sceneManager.toggleCameraPath();
            if (!pathAnimationWasStarted) {
                setFlag(true);
            }
        }

        function onKeyDown(event: KeyboardEvent): void {
            if (event.key === ' ' && props.app.sceneManager.cameraPathInfo.available) {
                onStartAnimation();
                event.preventDefault();
            }
        }

        React.useEffect(
            () => {
                window.addEventListener('keydown', onKeyDown);
                return () => window.removeEventListener('keydown', onKeyDown);
            }
        );

        if (!props.app.sceneManager.cameraPathInfo.available) {
            return null;
        }

        return (
            <IconButton onClick={onStartAnimation}>
                {props.app.sceneManager.cameraPathInfo.playing === 'STARTED' ?
                    <PauseIcon/> :
                    <PlayIcon className={pathAnimationWasStarted ? undefined : classes.animatedButton}/>
                }
            </IconButton>
         );
    }
);

CameraPathButton.displayName = 'CameraPathButton';